import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Box, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { UNATHORIZED } from '../../common/constants/routes.constants';
import { useUserStore } from '../../store/useUserStore';
import { getUserAdministrationInfo } from '../../api/auth.api';

const CallbackPage: React.FC = () => {
  const { isLoading, user } = useAuth0();
  const navigate = useNavigate();
  const { setUserInfo } = useUserStore();

  useEffect(() => {
    if (!isLoading && user) {
      checkUserRole();
    }
  }, [isLoading, user]);

  const checkUserRole = async () => {
    try {
      const response = await getUserAdministrationInfo();

      const { isAdmin, isSuperAdmin } = response;
      const isAuthorized = isAdmin || isSuperAdmin;
      setUserInfo(response);
      navigate(isAuthorized ? '/' : UNATHORIZED);
    } catch (err) {
      navigate(UNATHORIZED);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%'
      }}
    >
      <CircularProgress />
    </Box>
  );
};

export default CallbackPage;
